import React from 'react';
import { Box } from '@mui/material';
import Navigation from '../Navigation';
import Footer from '../Footer';

function Layout({ children }) {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      minHeight: '100vh',
      position: 'relative' 
    }}>
      <Navigation />
      <Box sx={{ 
        flexGrow: 1,
        width: '100%',
        zIndex: 0
      }}>
        {children}
      </Box>
      <Footer />
    </Box>
  );
}

export default Layout;
